import { render, staticRenderFns } from "./BalanceCallout.vue?vue&type=template&id=a4bdf15a"
import script from "./BalanceCallout.vue?vue&type=script&lang=js"
export * from "./BalanceCallout.vue?vue&type=script&lang=js"
import style0 from "./BalanceCallout.vue?vue&type=style&index=0&id=a4bdf15a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports